import { baseRequest } from "./APIServices";
const action = "authenticate";
const tokenName = 'token';
const refreshTokenName = 'refresh-token';
const memberName = 'member';
const tUser = { Name: '', Family: '', Image: '', Menu: '', ID: 0 };
const getUserInfo = () => localStorage.getItem(memberName) ? JSON.parse(localStorage.getItem(memberName)) : tUser;
export const authenticationServices = {

    login: async (data) => {
        const response = await baseRequest("post", action, "login", data, false);
        if (response.Succeed) {
            let res = response.Data;
            let token = res.Token;
            localStorage.setItem(tokenName, token);
            localStorage.setItem(refreshTokenName, res.RefreshToken);
            localStorage.setItem(memberName, JSON.stringify(res.Member))
        }
        return response;
    },
    logout: async () => {
        localStorage.removeItem(tokenName);
        localStorage.removeItem(refreshTokenName);
        localStorage.removeItem(memberName);
        window.location.reload();
    },
    loginWithToken: async () => {
        const data = { Token: localStorage.getItem(tokenName), RefreshToken: localStorage.getItem(refreshTokenName) };
        const response = await baseRequest("post", action, "NewToken", data);
        if (response.Succeed) {
            let res = response.Data;
            let token = res.Token;
            localStorage.setItem(tokenName, token);
            localStorage.setItem(refreshTokenName, res.RefreshToken);
            return true;
        }
        return false;
    },
    forgotPassword: async (data) => {
        return await baseRequest("post", action, "ForgotPassword", data, false);
    },
    checkAuthCode: async (data) => {
        return await baseRequest("post", action, "CheckAuthCode", data, false);
    },
    retrievePassword: async (data) => {
        return await baseRequest("post", action, "RetrievePassword", data, false);
    },
    authenticate: async (data) => {
        return await baseRequest("post", action, "Authenticate", data);
    },
    isAuthenticate: () => localStorage.getItem(tokenName) ? true : false,
    refreshToken: localStorage.getItem(refreshTokenName),
    getToken: () => localStorage.getItem(tokenName),
    userInfo: getUserInfo(),
    tempUser: tUser
};
